export default class DeferImages {
  constructor() {
    this.initializeLazyImages();
  }

  public deferBackgroundImages() {
    const imgDefer = document.querySelectorAll("div[data-src]");
    const style = "background-image: url({url})";
    for (let i = 0; i < imgDefer.length; i++) {
      imgDefer[i].setAttribute("style", style.replace("{url}", imgDefer[i].getAttribute("data-src")));
    }
  }

  public initializeLazyImages() {
    // Get images that has the data-src attribute
    const lazyImages = document.querySelectorAll("[data-src]");

    // If browser doesn't support IntersectionObserver, load all images
    if (!("IntersectionObserver" in window)) {
      for (let i = 0; i < lazyImages.length; i++) {
        const imageElement = lazyImages[i];
        loadImage(imageElement);
      }
    } else {
      // Create observer
      const observer = new IntersectionObserver(
        (entries) => {
          for (let i = 0; i < entries.length; i++) {
            const entry = entries[i];

            if (entry.intersectionRatio <= 0) {
              continue;
            }

            const imageElement = entry.target;
            loadImage(imageElement);
            observer.unobserve(imageElement);
          }
        },
        // Configuration for the observer
        { rootMargin: "100px" } // load images if it gets within 100px
      );

      // Let all lazy images be observered
      for (let y = 0; y < lazyImages.length; y++) {
        const imageElement = lazyImages[y];
        observer.observe(imageElement);
      }
    }

    function loadImage(imageElement:any) {
      // If image is within a picture element, set srcset attribute for all source elements
      const parent = imageElement.parentNode;
      if (imageElement.tagName === "DIV" || imageElement.tagName === "SPAN") {
        const style = "background-image: url({url})";
        imageElement.setAttribute("style", style.replace("{url}", imageElement.getAttribute("data-src")));
      }
      if (imageElement.tagName === "IMG") {
        const src = imageElement.getAttribute("data-src");
        imageElement.setAttribute("src", src);
      }
      if (parent.tagName === "PICTURE") {
        const sourceElements = parent.querySelectorAll("source");
        for (let z = 0; z < sourceElements.length; z++) {
          const sourceElement = sourceElements[z];
          sourceElement.srcset = sourceElement.dataset.srcset;
        }
      }
    }
  }
}
